import type { LangMap } from "./index";

export const widgets: LangMap = {
  it: {
    section: "I tuoi widget",
    configure: "Configura",
    none: "Nessun widget attivo.",
    choose: "Scegli i widget",
    wizardTitle: "Configura i widget",
    step1: "Passo 1 di 3 · Scegli quali widget vedere in Home.",
    step2: "Passo 2 di 3 · Personalizza i dettagli.",
    step3: "Passo 3 di 3 · Portali anche sul telefono.",
    timerDuration: "Durata del timer",
    agendaCount: "Impegni da mostrare",
    nothingToCustomize: "Niente da personalizzare per i widget scelti.",
    homeTitle: "Widget sulla schermata Home",
    iphoneHint: "iPhone: apri la pagina widget in Safari → Condividi → “Aggiungi a Home”.",
    androidHint: "Android: menù del browser → “Aggiungi a schermata Home”.",
    openPage: "Apri la pagina widget",
    back: "Indietro",
    continue: "Continua",
    done: "Fatto",
    kinds: {
      reminder: { title: "Promemoria verifiche", sub: "Prossima verifica + frase motivazionale" },
      timer: { title: "Timer di studio", sub: "Avvia una sessione al volo" },
      progress: { title: "Progressi", sub: "Streak, livello e XP" },
      agenda: { title: "Prossimi impegni", sub: "Compiti, verifiche ed eventi" },
    },
    card: {
      reminder: "Promemoria di studio",
      noExam: "Nessuna verifica in vista",
      inDays_one: "{{subject}} tra {{count}} giorno",
      inDays_other: "{{subject}} tra {{count}} giorni",
      streak_one: "{{count}} giorno di fila",
      streak_other: "{{count}} giorni di fila",
      timer: "Timer di studio",
      pause: "Pausa",
      start: "Avvia",
      reset: "Reset",
      agenda: "Prossimi impegni",
      agendaEmpty: "Tutto libero, per ora.",
      progress: "Progressi",
      levelShort: "Lv {{n}}",
      xp: "{{n}} XP",
    },
    quotes: [
      "Un capitolo oggi vale dieci ripassi domani.",
      "Non serve essere perfetti: serve iniziare.",
      "Venti minuti fatti bene battono due ore distratte.",
      "Ogni pagina letta è un pezzo di ansia in meno.",
      "Il futuro te ti ringrazierà per oggi.",
      "Piccoli passi, ogni giorno: è così che si vince.",
      "Studiare adesso significa essere libero dopo.",
    ],
    settings: {
      subtitle: "Scegli quali moduli mostrare nel widget e da quale profilo prendere i dati.",
      modulesTitle: "Moduli del widget",
      modulesHint: "Attiva solo quelli che vuoi vedere in Home.",
      studentOnly: "Disponibile solo per il profilo studente.",
      keepOne: "Almeno un modulo deve restare attivo.",
      profileTitle: "Profilo dei dati",
      profileHint: "Il widget mostra i dati del profilo scelto.",
      singleProfile: "Hai un solo profilo: aggiungine un altro dalle impostazioni profili.",
      previewTitle: "Anteprima",
    },
    page: {
      metaTitle: "Widget di studio · Lumen",
      metaDescription:
        "Aggiungi Lumen alla schermata Home: promemoria di studio con frase motivazionale, timer o prossime verifiche.",
      metaOgDescription: "Il tuo studio, sempre a portata di tap.",
      title: "Widget di studio",
      subtitle: "Scegli il widget, poi aggiungi questa pagina alla schermata Home del telefono.",
      tabReminder: "Promemoria",
      tabTimer: "Timer",
      tabAgenda: "Impegni",
      howTo: "Come metterlo in Home",
      iphoneHint: "iPhone: apri questa pagina in Safari → Condividi → “Aggiungi a Home”.",
      androidHint: "Android: menù del browser → “Aggiungi a schermata Home”.",
      backToApp: "Torna a Lumen",
    },
  },
  en: {
    section: "Your widgets",
    configure: "Configure",
    none: "No active widgets.",
    choose: "Choose widgets",
    wizardTitle: "Configure widgets",
    step1: "Step 1 of 3 · Choose which widgets to see on Home.",
    step2: "Step 2 of 3 · Customize the details.",
    step3: "Step 3 of 3 · Add them to your phone too.",
    timerDuration: "Timer duration",
    agendaCount: "Items to show",
    nothingToCustomize: "Nothing to customize for the widgets you picked.",
    homeTitle: "Widgets on your Home screen",
    iphoneHint: "iPhone: open the widget page in Safari → Share → “Add to Home Screen”.",
    androidHint: "Android: browser menu → “Add to Home screen”.",
    openPage: "Open the widget page",
    back: "Back",
    continue: "Continue",
    done: "Done",
    kinds: {
      reminder: { title: "Exam reminder", sub: "Next test + motivational quote" },
      timer: { title: "Study timer", sub: "Start a session in one tap" },
      progress: { title: "Progress", sub: "Streak, level and XP" },
      agenda: { title: "Upcoming items", sub: "Homework, tests and events" },
    },
    card: {
      reminder: "Study reminder",
      noExam: "No tests coming up",
      inDays_one: "{{subject}} in {{count}} day",
      inDays_other: "{{subject}} in {{count}} days",
      streak_one: "{{count}} day streak",
      streak_other: "{{count}} day streak",
      timer: "Study timer",
      pause: "Pause",
      start: "Start",
      reset: "Reset",
      agenda: "Upcoming",
      agendaEmpty: "Nothing scheduled for now.",
      progress: "Progress",
      levelShort: "Lv {{n}}",
      xp: "{{n}} XP",
    },
    quotes: [
      "One chapter today beats ten reviews tomorrow.",
      "You don't need to be perfect: you need to start.",
      "Twenty focused minutes beat two distracted hours.",
      "Every page you read is one less worry.",
      "Future you will thank present you.",
      "Small steps, every day: that's how you win.",
      "Studying now means being free later.",
    ],
    settings: {
      subtitle: "Choose which modules the widget shows and which profile the data comes from.",
      modulesTitle: "Widget modules",
      modulesHint: "Turn on only what you want on your Home screen.",
      studentOnly: "Available for the student profile only.",
      keepOne: "At least one module must stay on.",
      profileTitle: "Data profile",
      profileHint: "The widget shows data from the selected profile.",
      singleProfile: "You only have one profile: add another one in profile settings.",
      previewTitle: "Preview",
    },
    page: {
      metaTitle: "Study widgets · Lumen",
      metaDescription:
        "Add Lumen to your Home screen: study reminder with a motivational quote, timer or upcoming tests.",
      metaOgDescription: "Your study, always one tap away.",
      title: "Study widgets",
      subtitle: "Pick a widget, then add this page to your phone's Home screen.",
      tabReminder: "Reminder",
      tabTimer: "Timer",
      tabAgenda: "Agenda",
      howTo: "How to add it to Home",
      iphoneHint: "iPhone: open this page in Safari → Share → “Add to Home Screen”.",
      androidHint: "Android: browser menu → “Add to Home screen”.",
      backToApp: "Back to Lumen",
    },
  },
  es: {
    section: "Tus widgets",
    configure: "Configurar",
    none: "No hay widgets activos.",
    choose: "Elige los widgets",
    wizardTitle: "Configurar widgets",
    step1: "Paso 1 de 3 · Elige qué widgets ver en Inicio.",
    step2: "Paso 2 de 3 · Personaliza los detalles.",
    step3: "Paso 3 de 3 · Llévalos también al móvil.",
    timerDuration: "Duración del temporizador",
    agendaCount: "Elementos a mostrar",
    nothingToCustomize: "Nada que personalizar para los widgets elegidos.",
    homeTitle: "Widgets en la pantalla de inicio",
    iphoneHint: "iPhone: abre la página de widgets en Safari → Compartir → “Añadir a inicio”.",
    androidHint: "Android: menú del navegador → “Añadir a pantalla de inicio”.",
    openPage: "Abrir la página de widgets",
    back: "Atrás",
    continue: "Continuar",
    done: "Hecho",
    kinds: {
      reminder: { title: "Recordatorio de exámenes", sub: "Próximo examen + frase motivadora" },
      timer: { title: "Temporizador de estudio", sub: "Inicia una sesión al instante" },
      progress: { title: "Progreso", sub: "Racha, nivel y XP" },
      agenda: { title: "Próximos compromisos", sub: "Tareas, exámenes y eventos" },
    },
    card: {
      reminder: "Recordatorio de estudio",
      noExam: "No hay exámenes a la vista",
      inDays_one: "{{subject}} en {{count}} día",
      inDays_other: "{{subject}} en {{count}} días",
      streak_one: "{{count}} día seguido",
      streak_other: "{{count}} días seguidos",
      timer: "Temporizador de estudio",
      pause: "Pausa",
      start: "Iniciar",
      reset: "Reiniciar",
      agenda: "Próximos compromisos",
      agendaEmpty: "Todo libre, por ahora.",
      progress: "Progreso",
      levelShort: "Nv {{n}}",
      xp: "{{n}} XP",
    },
    quotes: [
      "Un capítulo hoy vale diez repasos mañana.",
      "No hace falta ser perfecto: hace falta empezar.",
      "Veinte minutos bien hechos ganan a dos horas distraídas.",
      "Cada página leída es un poco menos de ansiedad.",
      "Tu yo del futuro te lo agradecerá.",
      "Pequeños pasos, cada día: así se gana.",
      "Estudiar ahora significa ser libre después.",
    ],
    settings: {
      subtitle: "Elige qué módulos muestra el widget y de qué perfil toma los datos.",
      modulesTitle: "Módulos del widget",
      modulesHint: "Activa solo lo que quieres ver en inicio.",
      studentOnly: "Solo disponible para el perfil de estudiante.",
      keepOne: "Debe quedar al menos un módulo activo.",
      profileTitle: "Perfil de los datos",
      profileHint: "El widget muestra los datos del perfil elegido.",
      singleProfile: "Solo tienes un perfil: añade otro en los ajustes de perfiles.",
      previewTitle: "Vista previa",
    },
    page: {
      metaTitle: "Widgets de estudio · Lumen",
      metaDescription:
        "Añade Lumen a tu pantalla de inicio: recordatorio de estudio con frase motivadora, temporizador o próximos exámenes.",
      metaOgDescription: "Tu estudio, siempre a un toque.",
      title: "Widgets de estudio",
      subtitle: "Elige el widget y añade esta página a la pantalla de inicio del móvil.",
      tabReminder: "Recordatorio",
      tabTimer: "Temporizador",
      tabAgenda: "Compromisos",
      howTo: "Cómo ponerlo en Inicio",
      iphoneHint: "iPhone: abre esta página en Safari → Compartir → “Añadir a inicio”.",
      androidHint: "Android: menú del navegador → “Añadir a pantalla de inicio”.",
      backToApp: "Volver a Lumen",
    },
  },
  fr: {
    section: "Tes widgets",
    configure: "Configurer",
    none: "Aucun widget actif.",
    choose: "Choisir les widgets",
    wizardTitle: "Configurer les widgets",
    step1: "Étape 1 sur 3 · Choisis les widgets à voir sur l'accueil.",
    step2: "Étape 2 sur 3 · Personnalise les détails.",
    step3: "Étape 3 sur 3 · Ajoute-les aussi sur ton téléphone.",
    timerDuration: "Durée du minuteur",
    agendaCount: "Éléments à afficher",
    nothingToCustomize: "Rien à personnaliser pour les widgets choisis.",
    homeTitle: "Widgets sur l'écran d'accueil",
    iphoneHint: "iPhone : ouvre la page widget dans Safari → Partager → « Sur l'écran d'accueil ».",
    androidHint: "Android : menu du navigateur → « Ajouter à l'écran d'accueil ».",
    openPage: "Ouvrir la page widget",
    back: "Retour",
    continue: "Continuer",
    done: "Terminé",
    kinds: {
      reminder: { title: "Rappel de contrôles", sub: "Prochain contrôle + phrase motivante" },
      timer: { title: "Minuteur d'étude", sub: "Lance une session en un geste" },
      progress: { title: "Progrès", sub: "Série, niveau et XP" },
      agenda: { title: "Prochaines échéances", sub: "Devoirs, contrôles et événements" },
    },
    card: {
      reminder: "Rappel d'étude",
      noExam: "Aucun contrôle en vue",
      inDays_one: "{{subject}} dans {{count}} jour",
      inDays_other: "{{subject}} dans {{count}} jours",
      streak_one: "{{count}} jour d'affilée",
      streak_other: "{{count}} jours d'affilée",
      timer: "Minuteur d'étude",
      pause: "Pause",
      start: "Démarrer",
      reset: "Réinitialiser",
      agenda: "Prochaines échéances",
      agendaEmpty: "Rien de prévu pour l'instant.",
      progress: "Progrès",
      levelShort: "Niv {{n}}",
      xp: "{{n}} XP",
    },
    quotes: [
      "Un chapitre aujourd'hui vaut dix révisions demain.",
      "Pas besoin d'être parfait : il faut commencer.",
      "Vingt minutes concentrées valent mieux que deux heures distraites.",
      "Chaque page lue, c'est un peu moins de stress.",
      "Ton toi du futur te remerciera.",
      "De petits pas, chaque jour : c'est ainsi qu'on gagne.",
      "Étudier maintenant, c'est être libre plus tard.",
    ],
    settings: {
      subtitle: "Choisis les modules affichés par le widget et le profil source des données.",
      modulesTitle: "Modules du widget",
      modulesHint: "Active seulement ce que tu veux voir sur l'écran d'accueil.",
      studentOnly: "Disponible uniquement pour le profil élève.",
      keepOne: "Au moins un module doit rester actif.",
      profileTitle: "Profil des données",
      profileHint: "Le widget affiche les données du profil choisi.",
      singleProfile: "Tu n'as qu'un profil : ajoutes-en un autre dans les réglages des profils.",
      previewTitle: "Aperçu",
    },
    page: {
      metaTitle: "Widgets d'étude · Lumen",
      metaDescription:
        "Ajoute Lumen à ton écran d'accueil : rappel d'étude avec phrase motivante, minuteur ou prochains contrôles.",
      metaOgDescription: "Tes révisions, toujours à portée de doigt.",
      title: "Widgets d'étude",
      subtitle: "Choisis le widget, puis ajoute cette page à l'écran d'accueil de ton téléphone.",
      tabReminder: "Rappel",
      tabTimer: "Minuteur",
      tabAgenda: "Échéances",
      howTo: "Comment l'ajouter à l'accueil",
      iphoneHint: "iPhone : ouvre cette page dans Safari → Partager → « Sur l'écran d'accueil ».",
      androidHint: "Android : menu du navigateur → « Ajouter à l'écran d'accueil ».",
      backToApp: "Retour à Lumen",
    },
  },
  de: {
    section: "Deine Widgets",
    configure: "Einrichten",
    none: "Keine aktiven Widgets.",
    choose: "Widgets auswählen",
    wizardTitle: "Widgets einrichten",
    step1: "Schritt 1 von 3 · Wähle die Widgets für den Start.",
    step2: "Schritt 2 von 3 · Details anpassen.",
    step3: "Schritt 3 von 3 · Bring sie auch aufs Handy.",
    timerDuration: "Timer-Dauer",
    agendaCount: "Anzuzeigende Einträge",
    nothingToCustomize: "Für die gewählten Widgets gibt es nichts anzupassen.",
    homeTitle: "Widgets auf dem Home-Bildschirm",
    iphoneHint: "iPhone: Widget-Seite in Safari öffnen → Teilen → „Zum Home-Bildschirm“.",
    androidHint: "Android: Browser-Menü → „Zum Startbildschirm hinzufügen“.",
    openPage: "Widget-Seite öffnen",
    back: "Zurück",
    continue: "Weiter",
    done: "Fertig",
    kinds: {
      reminder: { title: "Prüfungs-Erinnerung", sub: "Nächste Prüfung + Motivationssatz" },
      timer: { title: "Lern-Timer", sub: "Starte sofort eine Sitzung" },
      progress: { title: "Fortschritt", sub: "Serie, Level und XP" },
      agenda: { title: "Nächste Termine", sub: "Hausaufgaben, Prüfungen und Termine" },
    },
    card: {
      reminder: "Lern-Erinnerung",
      noExam: "Keine Prüfung in Sicht",
      inDays_one: "{{subject}} in {{count}} Tag",
      inDays_other: "{{subject}} in {{count}} Tagen",
      streak_one: "{{count}} Tag in Folge",
      streak_other: "{{count}} Tage in Folge",
      timer: "Lern-Timer",
      pause: "Pause",
      start: "Start",
      reset: "Zurücksetzen",
      agenda: "Nächste Termine",
      agendaEmpty: "Aktuell nichts geplant.",
      progress: "Fortschritt",
      levelShort: "Lv {{n}}",
      xp: "{{n}} XP",
    },
    quotes: [
      "Ein Kapitel heute ist zehn Wiederholungen morgen wert.",
      "Du musst nicht perfekt sein — du musst anfangen.",
      "Zwanzig konzentrierte Minuten schlagen zwei abgelenkte Stunden.",
      "Jede gelesene Seite ist ein Stück weniger Stress.",
      "Dein zukünftiges Ich wird dir danken.",
      "Kleine Schritte, jeden Tag: so gewinnt man.",
      "Jetzt lernen heißt später frei sein.",
    ],
    settings: {
      subtitle: "Wähle, welche Module das Widget zeigt und aus welchem Profil die Daten kommen.",
      modulesTitle: "Widget-Module",
      modulesHint: "Aktiviere nur, was du auf dem Homescreen sehen willst.",
      studentOnly: "Nur für das Schüler-Profil verfügbar.",
      keepOne: "Mindestens ein Modul muss aktiv bleiben.",
      profileTitle: "Datenprofil",
      profileHint: "Das Widget zeigt die Daten des gewählten Profils.",
      singleProfile: "Du hast nur ein Profil: füge in den Profileinstellungen ein weiteres hinzu.",
      previewTitle: "Vorschau",
    },
    page: {
      metaTitle: "Lern-Widgets · Lumen",
      metaDescription:
        "Füge Lumen zum Home-Bildschirm hinzu: Lern-Erinnerung mit Motivationssatz, Timer oder nächste Prüfungen.",
      metaOgDescription: "Dein Lernen, immer nur einen Tipp entfernt.",
      title: "Lern-Widgets",
      subtitle: "Wähle das Widget und füge diese Seite dem Home-Bildschirm hinzu.",
      tabReminder: "Erinnerung",
      tabTimer: "Timer",
      tabAgenda: "Termine",
      howTo: "So kommt es auf den Home-Bildschirm",
      iphoneHint: "iPhone: diese Seite in Safari öffnen → Teilen → „Zum Home-Bildschirm“.",
      androidHint: "Android: Browser-Menü → „Zum Startbildschirm hinzufügen“.",
      backToApp: "Zurück zu Lumen",
    },
  },
  pt: {
    section: "Os teus widgets",
    configure: "Configurar",
    none: "Nenhum widget ativo.",
    choose: "Escolher widgets",
    wizardTitle: "Configurar widgets",
    step1: "Passo 1 de 3 · Escolhe que widgets ver no Início.",
    step2: "Passo 2 de 3 · Personaliza os detalhes.",
    step3: "Passo 3 de 3 · Leva-os também para o telemóvel.",
    timerDuration: "Duração do temporizador",
    agendaCount: "Itens a mostrar",
    nothingToCustomize: "Nada para personalizar nos widgets escolhidos.",
    homeTitle: "Widgets no ecrã inicial",
    iphoneHint: "iPhone: abre a página de widgets no Safari → Partilhar → “Adicionar ao ecrã principal”.",
    androidHint: "Android: menu do navegador → “Adicionar ao ecrã principal”.",
    openPage: "Abrir a página de widgets",
    back: "Voltar",
    continue: "Continuar",
    done: "Concluído",
    kinds: {
      reminder: { title: "Lembrete de testes", sub: "Próximo teste + frase motivacional" },
      timer: { title: "Temporizador de estudo", sub: "Começa uma sessão num toque" },
      progress: { title: "Progresso", sub: "Sequência, nível e XP" },
      agenda: { title: "Próximos compromissos", sub: "Trabalhos, testes e eventos" },
    },
    card: {
      reminder: "Lembrete de estudo",
      noExam: "Nenhum teste à vista",
      inDays_one: "{{subject}} em {{count}} dia",
      inDays_other: "{{subject}} em {{count}} dias",
      streak_one: "{{count}} dia seguido",
      streak_other: "{{count}} dias seguidos",
      timer: "Temporizador de estudo",
      pause: "Pausa",
      start: "Iniciar",
      reset: "Reiniciar",
      agenda: "Próximos compromissos",
      agendaEmpty: "Tudo livre, por agora.",
      progress: "Progresso",
      levelShort: "Nv {{n}}",
      xp: "{{n}} XP",
    },
    quotes: [
      "Um capítulo hoje vale dez revisões amanhã.",
      "Não é preciso ser perfeito: é preciso começar.",
      "Vinte minutos focados valem mais que duas horas distraídas.",
      "Cada página lida é menos um bocado de ansiedade.",
      "O teu eu do futuro vai agradecer-te.",
      "Pequenos passos, todos os dias: é assim que se ganha.",
      "Estudar agora significa ser livre depois.",
    ],
    settings: {
      subtitle: "Escolhe que módulos o widget mostra e de que perfil vêm os dados.",
      modulesTitle: "Módulos do widget",
      modulesHint: "Ativa só o que queres ver no ecrã inicial.",
      studentOnly: "Disponível apenas para o perfil de estudante.",
      keepOne: "Pelo menos um módulo tem de ficar ativo.",
      profileTitle: "Perfil dos dados",
      profileHint: "O widget mostra os dados do perfil escolhido.",
      singleProfile: "Tens apenas um perfil: adiciona outro nas definições de perfis.",
      previewTitle: "Pré-visualização",
    },
    page: {
      metaTitle: "Widgets de estudo · Lumen",
      metaDescription:
        "Adiciona o Lumen ao ecrã inicial: lembrete de estudo com frase motivacional, temporizador ou próximos testes.",
      metaOgDescription: "O teu estudo, sempre à distância de um toque.",
      title: "Widgets de estudo",
      subtitle: "Escolhe o widget e adiciona esta página ao ecrã inicial do telemóvel.",
      tabReminder: "Lembrete",
      tabTimer: "Temporizador",
      tabAgenda: "Compromissos",
      howTo: "Como colocar no ecrã inicial",
      iphoneHint: "iPhone: abre esta página no Safari → Partilhar → “Adicionar ao ecrã principal”.",
      androidHint: "Android: menu do navegador → “Adicionar ao ecrã principal”.",
      backToApp: "Voltar ao Lumen",
    },
  },
};
